export const BymaScrollSeparator: React.FC<{
  date: string;
}> = ({ date }) => {
  return (
    <div className="flex flex-row items-center gap-2 p-2">
      <p className="w-36 truncate text-lg font-semibold text-[--milkylb-color-neutral-200]">
        {date}
      </p>
      <div className="h-[2px] w-full bg-[--milkylb-color-neutral-100]" />
    </div>
  );
};
